import { api } from "../api/api";
import { PurchaseOrderInvoiceMockData } from "../util/mock-data/PurchaseOrderInvoiceMockData";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getPurchaseOrderInvoiceDetails = async (params) => {
  try {
    const response = await api.get("/api/PurchaseOrderInvoiceRecieves", {
      params
    });
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};
